<!--
   TODO
    This component needs the gfas to be integrated
    Some of the html blocks with the parent function calls will be commented out until it is created
-->
<div>
  <!-- Recalls Box -->
  <!--  NOTE [ngSubmit]="ForRecalls(vin)" was originally in form tag, but ForRecalls is unused in the app-->
  <form [formGroup]="recallSearchForm">
    <div>
      <div
        class="gb-headline2 mb-3"
        role="heading"
        aria-level="2"
        [translate]="'recallCenter_search_header'"
      ></div>
      <div [ngSwitch]="isAnotherSearch">
        <div *ngSwitchCase="false">
          <div>
            <div
              class="gb-body1"
              [translateParams]="{refreshDate: refreshDate}"
              [translate]="'recallCenter_landing_lastUpdated_label'"
            ></div>
          </div>
          <hr />
          <span
            class="gb-body1"
            [translate]="'recallCenter_search_subtext'"
          ></span>
        </div>
        <p
          class="gb-body1"
          *ngSwitchCase="true"
          [translate]="'recallCenter_search_subtext'"
        ></p>
      </div>
    </div>
    <!-- Search Form -->
    <div>
      <!--Error Messages -->
      <!--      <p class="oc-alert-error" *ngIf="invalidVinError">-->
      <!--        <span aria-atomic="true" role="alert" [translate]="'rtext_recallCenter_error_invalidVin'"></span>-->
      <!--      </p>-->

      <!--      <p class="oc-alert-error" *ngIf="serverError">-->
      <!--        <span aria-atomic="true" role="alert" [translate]="'rtext_recallCenter_error_serverError'"></span>-->
      <!--      </p>-->
      <!-- Search Form and Button -->
      <div class="row mt-3">
        <div class="col-12">
          <div class="d-flex">
            <div class="w-100 form-search-input">
              <div
                [trackLink]="'recalls:textBox:vin'"
                [trackDelay]="'true'"
                [trackType]="'o'"
                [prop10]="'recalls:textBox:Enter your VIN'"
              >
                <div>
                  <ox-text-input
                    [inputName]="'vin'"
                    [classes]="'form-control'"
                    [type]="'text'"
                    [label]="'recallCenter_search_enterVin_label'"
                    [required]="'true'"
                    [validationType]="'alphanumeric'"
                    [id]="'Recalls_VinInput'"
                    [formGroupInput]="recallSearchForm"
                    [formControlNameInput]="'searchInput'"
                    [maxLength]="vinAttributes.maxlength"
                  >
                  </ox-text-input>
                </div>
              </div>
            </div>
            <span>
              <button
                (click)="searchForRecalls(recallSearchForm.value)"
                [translate]="'recallCenter_search_button'"
                aria-label="'recallCenter_search_button' | translate"
                class="gb-primary-button mt-2 mt-lg-0"
              ></button>
            </span>
          </div>
        </div>
      </div>
      <!-- WHERE'S MY VIN TOOLTIP -->
      <ox-tooltip
        [track]="'Garage:WhereMyVin'"
        [trackDelay]="'true'"
        [trackType]="'o'"
        [prop10]="'Garage:Add a Vehicle:textlink:where\'s my vin'"
        [evar33]="'Garage:Add a Vehicle:textlink:where\'s my vin'"
        [prop15]="'where\'s+ my vin'"
        [trackFirstClickOnly]="'true'"
      >
        <span class="title">{{'addVehicle_tooltipTitle' | translate}}</span>
        <div class="content">
          {{'rtext_addVehicle_tooltipContent' | translate}}
        </div>
      </ox-tooltip>
    </div>
    <div [hidden]="isAnotherSearch">
      <hr />
      <div
        class="gb-headline2 mb-3"
        [translate]="'recallCenter_landing_faqs_header'"
      ></div>
      <ox-expander-collapse-dynamic-group
        [collection]="landingFaq"
      ></ox-expander-collapse-dynamic-group>
    </div>
    <hr />
    <div>
      <div
        class="gb-body1"
        [translate]="'recallCenter_searchField_subtext'"
      ></div>
    </div>
  </form>
</div>
